import { render, staticRenderFns } from "./VerifiyAccount.vue?vue&type=template&id=21b9164c"
import script from "./VerifiyAccount.vue?vue&type=script&lang=js"
export * from "./VerifiyAccount.vue?vue&type=script&lang=js"
import style0 from "./VerifiyAccount.vue?vue&type=style&index=0&id=21b9164c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports